import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute,Params } from '@angular/router';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { TaskLinked,TaskAllocation,addUser,DailyToken,DailyTokenItem, TaskDayToken, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-man-pow-alloc',
  templateUrl: './man-pow-alloc.component.html',
  styleUrls: ['./man-pow-alloc.component.css']
})
export class ManPowAllocComponent implements OnInit {

  datatables:TaskAllocation;
  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';
  areChangesMade: boolean = false;

  selView:number = 1;
  daywiseItemList: Array<DailyToken>;
  currMonthDtObj:Date = new Date();
  WorkDayTokenObj:TaskDayToken;
  mId:string = "72b9d798-a413-408c-940e-9cd2bfbaa407";

  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;
  
  constructor(private _dataService:DataService,private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Man-Power Allocation";
    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
    });
  }
   hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }
  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadManPowerAllocation(this.currMonthDtObj).subscribe((_cstInspPlan:TaskAllocation) => {
        if(_cstInspPlan!=null){
          this.datatables = _cstInspPlan;
           this.loadDateData();
          
          let _tmpDailyTokenList: Array<DailyToken> = [];
            for (var i = 0; i < this.datatables.dayTokens.length; i++) {
              let _tmpDate:Date = this.datatables.dayTokens[i].selDate;
              let _tmpDailyTokens:Array<DailyTokenItem> = [];            
              let _indexer:number = 0;
              this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj:TaskLinked) => {                               
                var isFound = false;
                for(var h=0;h<_tmpDailyTokens.length;h++){   
                  if(_tmpDailyTokens[h].name == _tmpObj.workCategoryName){
                    isFound = true;
                  }                 
                }
                if(!isFound){
                  _tmpDailyTokens.push(new DailyTokenItem( _tmpObj.workCategoryName, this.getIdObj(_tmpDate,_indexer),''));
                }
                _indexer++;
              });
              _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
            }
          this.daywiseItemList = _tmpDailyTokenList;          
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
          this.loadEmployeeList();
        }
        else{
          this.daywiseItemList = []
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-MM-YYYY");
    }
    return '-';
  }
  checkDate(sel,cur){
    return sel.getDate()==cur.getDate() && sel.getMonth() == cur.getMonth() && sel.getFullYear() == cur.getFullYear()
  }
  loadDateData():void{
    var isFound = false;
    let _tmpDPHDayToken:TaskDayToken= new TaskDayToken(null,[]);
    for(var i=0;i<this.datatables.dayTokens.length;i++){
      if(this.checkDate(this.datatables.dayTokens[i].selDate,this.currMonthDtObj)){
        isFound = true;
        _tmpDPHDayToken = this.datatables.dayTokens[i]
      }
    }
    if(!isFound){
      _tmpDPHDayToken.selDate = this.currMonthDtObj;
      _tmpDPHDayToken.clearDayToken = [];
      for(var j=0;j<this._dataService.manPowerAllctn.workCategories.length;j++){
          var _wrk = this._dataService.manPowerAllctn.workCategories[j];
            for(var k=0;k<_wrk.task.length;k++){
              _tmpDPHDayToken.addToken(new TaskLinked(_wrk.workCategoryId,_wrk.workCategoryName,_wrk.task[k].taskId,_wrk.task[k].taskName,[],''))
            }
      }
      
    }
   // console.log(_tmpDPHDayToken)
    // console.log(this.datatables.getDateToken(this.currMonthDtObj))
    // let _tmpDPHDayToken:TaskDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    // if(_tmpDPHDayToken){
    //     _tmpDPHDayToken.selDate=this.currMonthDtObj;
    //     if(_tmpDPHDayToken.dateTokens.length==0){
    //       for(var j=0;j<this._dataService.manPowerAllctn.workCategories.length;j++){
    //             var _wrk = this._dataService.manPowerAllctn.workCategories[j];
    //               for(var k=0;k<_wrk.task.length;k++){
    //               _tmpDPHDayToken.addToken(new TaskLinked(_wrk.workCategoryId,_wrk.workCategoryName,_wrk.task[k].taskId,_wrk.task[k].taskName,[]))
    //               }
    //         }
    //   }
    // }
    // console.log(_tmpDPHDayToken)
    // console.log(this.datatables.getDateToken(this.currMonthDtObj))
    // let _tmpDPHDayToken:TaskDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    // if(_tmpDPHDayToken){
    //   this.datatables.addDateToken(this.currMonthDtObj);
    //   _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    // }   
    //   if(_tmpDPHDayToken.dateTokens.length==0){
    //   for(var j=0;j<this._dataService.manPowerAllctn.workCategories.length;j++){
    //     var _wrk = this._dataService.manPowerAllctn.workCategories[j];
    //       for(var k=0;k<_wrk.task.length;k++){
    //        _tmpDPHDayToken.addToken(new TaskLinked(_wrk.workCategoryId,_wrk.workCategoryName,_wrk.task[k].taskId,_wrk.task[k].taskName,[]))
    //       }
    // }
    // }  
    
    // this.WorkDayTokenObj = null;
    this.WorkDayTokenObj = _tmpDPHDayToken;
  }
  private getDisplayTokenName(_custId:string,_quantity:number){
    return this._dataService.getProductName(_custId) ;
  }
  
  discardData():void{
    this.loadMonthData();
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
  formatMonth(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "MMM-YYYY");
    }
    return '-';
  }
  private loadEmployeeList(){
    this._dataService.loadEmployeeList().subscribe((_result:boolean) => {
     // console.log(_result);
    });
  }
  newUserAdded(_useremail,index){
    let isFound = false;
    this.areChangesMade = true;
    if(this.WorkDayTokenObj){
      this.WorkDayTokenObj.dateTokens[index].addUser(new addUser(_useremail,_useremail))
    }
  }
  extUserRemoved(_useremail,indx){
    this.areChangesMade = true;
    if(this.WorkDayTokenObj){
      this.WorkDayTokenObj.dateTokens[indx].removeUser(_useremail)
    }
  }
  validateData():boolean{
    return true;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  saveData(_sendMail: boolean): void {
    if (this.validateData() == true) {
      this.datatables.dayToken = this.WorkDayTokenObj
      this._dataService.saveManPowerAllocation(this.datatables, _sendMail)
        .subscribe((resp: GenResponse) => {
          if (resp.status == DataService.statusFail) {
            if (resp.errorCode == DataService.staleDataCode) {
              this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
            } else {
              this._notify.error('Failure', resp.details, this._dataService.failureOptions);
            }
          }
          else {
            this._notify.success('Success', resp.details, this._dataService.successOptions);
            this.loadMonthData();
          }
        });
    }
  }
  public prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }
}
